const DEFAULT_SETTINGS = {
  /*
  fieldId: { // Same ID as supplied to <Input />
    value: '',
    defaultValue: '', // Update StepReview.jsx & relevant step(s) if you need to output
  }
  */

  /* Default Advanced Settings */
  batchSize: {
    defaultValue: '10000',
  },
  throttleEnabled: {
    value: false, // We want to default to true on render, but never compare the default
  },
  subscribeToAllLog: {
    value: true, // We want to default to true on render, but never compare the default
  },

  azureName: {
    value: '',
  },

  azureThrottleEnabled: {
    value: undefined,
  },

  pollingInterval: {
    value: 5,
  },

  azureBatchSize: {
    value: 100,
  },
  azureWaitTime: {
    value: 1,
  },

  proxyOptions: {
    value: '',
  },
  azureStoreFullMessage: {
    value: undefined,
  },
  contentTypes: {
    value: 'AZURE_SERVICES',
  },
  availableContents: {
    value:
      'Azure Services, JSON Array, Raw Text / Single JSON document, GELF (Newline Delimited), Text (Newline Delimited)',
  },
};

export default DEFAULT_SETTINGS;
